export const SUBSCRIBE = 'USER_TYPE/SUBSCRIBE';
export const SET_USER_TYPE = 'USER_TYPE/SET_USER_TYPE';

export const NOTIFICATIONS_SKIPPED = 'USERTYPE/NOTIFICATIONS_SKIPPED';
